<script setup>

import {ref, watch} from "vue";
import axios from "axios";


const props = defineProps({
    body: {
        type: String,
        required: true
    },
})

const editingMessage = ref(false)

const _body = ref(props.body)

const updateMessageContent = async () => {
    await axios.post(route('assistant.updateBaseMessage'), {
        messageBody: _body.value
    });
}

watch(editingMessage, (newValue) => {
    if (! newValue) {
        updateMessageContent();
    }
}, {deep: true});

</script>

<template>
<div>
    <div class="flex justify-between mb-2">
        <h2>{{ _mft('leadHunter:baseMessage') }}</h2>
        <button-base
            size="sm"
            :style-type="editingMessage ? 'success' : 'secondary'"
            @click="editingMessage = !editingMessage"
        >
            {{ editingMessage ? 'Done' : 'Edit' }}
        </button-base>
    </div>

    <div
        class="p-4 -mx-4 bg-gray-50 md:-mx-6 md:p-6"
    >
        <div class="flex items-center justify-between space-x-4">
            <span class="font-bold">{{ _mft('leadHunter:message.content') }}</span>
            <container-with-tooltip
                v-if="! editingMessage"
                alignment="center"
                tooltip-class="mb-1 bg-white text-xs px-1 py-0.5 rounded shadow-md text-xss"
            >
                <template #tooltip>
                    {{ _mft('shared:copy') }}
                </template>

                <copyable-text
                    :show-url="false"
                    :copyable-text="_body"
                />
            </container-with-tooltip>
        </div>

        <input-editor
            v-if="editingMessage"
            v-model:content="_body"
        />
        <div
            v-else
            v-html="_body"
        >
        </div>
    </div>
</div>
</template>

<style scoped>

</style>
